import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { BlurView } from '@sbaiahmed1/react-native-blur';
import React from 'react';
import { Dimensions, Image, Modal, Platform, StyleSheet } from 'react-native';
import styled from 'styled-components/native';
import { SccPressable } from '@/components/SccPressable';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
// Figma 1648:40812 popup img frame: 390x200 (frame 폭). 화면 폭 비례.
const SCREEN_WIDTH = Dimensions.get('window').width;
const POPUP_IMG_HEIGHT = SCREEN_WIDTH * (200 / 390);
export default function HiddenMissionCollectedPopup({ isVisible, onClose, }) {
    return (_jsxs(Modal, { visible: isVisible, transparent: true, animationType: "fade", statusBarTranslucent: true, onRequestClose: onClose, children: [_jsx(BlurView, { style: StyleSheet.absoluteFill, blurType: "dark", blurAmount: Platform.OS === 'ios' ? 35 : 6, overlayColor: "rgba(0,0,0,0.6)" }), _jsx(DimRoot, { children: _jsxs(ContentsWrapper, { children: [_jsx(TitleImage, { source: require('@/assets/img/tutorial/hidden_collected_title.png'), resizeMode: "contain" }), _jsx(Image, { source: require('@/assets/img/tutorial/mission_complete_img_hidden.png'), style: { width: SCREEN_WIDTH, height: POPUP_IMG_HEIGHT }, resizeMode: "contain" }), _jsxs(DescriptionWrapper, { children: [_jsx(Description, { children: '이제,\n새로운 곳으로 떠나봐요!' }), _jsx(ConfirmButton, { elementName: "tutorial_hidden_mission_collected_confirm", onPress: onClose, children: _jsx(ConfirmButtonText, { children: "\uD655\uC778" }) })] })] }) })] }));
}
const DimRoot = styled.View `
  flex: 1;
  align-items: center;
  justify-content: center;
`;
const ContentsWrapper = styled.View `
  align-items: center;
  width: 100%;
  gap: 20px;
`;
const TitleImage = styled.Image `
  width: 322px;
  height: 56px;
`;
const DescriptionWrapper = styled.View `
  align-items: center;
  gap: 20px;
`;
const Description = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 18px;
  line-height: 26px;
  letter-spacing: -0.4px;
  color: ${color.white};
  text-align: center;
  text-shadow-color: rgba(0, 0, 0, 0.25);
  text-shadow-radius: 4px;
  text-shadow-offset: 0px 0px;
`;
const ConfirmButton = styled(SccPressable) `
  width: 140px;
  height: 56px;
  background-color: ${color.brand40};
  border-radius: 8px;
  align-items: center;
  justify-content: center;
`;
const ConfirmButtonText = styled.Text `
  font-family: ${font.pretendardSemibold};
  font-size: 18px;
  line-height: 26px;
  letter-spacing: -0.36px;
  color: ${color.white};
`;
